module.exports = __webpack_public_path__ + "static/img/case_banner_04_h5.336d691.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_04_h5.png
// module id = /Ue9
// module chunks = 34